import { useState, useEffect } from 'react'
import _map from 'lodash/map'
import _get from 'lodash/get'
import { withRouter } from 'react-router-dom'
import { graphql, compose, withApollo } from 'react-apollo'

import { Constants } from '@sukiai/components'
import { GetScriptsByUserId, GetSections } from '@sukiai/gql/app'

import {
  CURRENT_SECTION,
  FETCH_POLICY,
  getScriptName,
  LO_STO,
  showScripts
} from '../../lib'
import loSto from '../../config/loSto'
import { SET_MODAL } from '../../apollo/actions'
import { EMBED_EMR } from '../../constants/embed'

const { MODALS } = Constants

function EmbedScripts ({ match, client }) {
  const [emr, setEmr] = useState()

  useEffect(() => {
    const emr = _get(match, 'params.emr')
    setEmr(emr)
  }, [])

  useEffect(() => {
    if (emr === EMBED_EMR.AMWELL) {
      client.mutate({
        mutation: SET_MODAL,
        variables: {
          content: {
            __typename: 'ModalContent',
            type: MODALS.AMWELL_SCRIPTS
          }
        }
      })
    }
  }, [emr])

  return null
}

export default compose(withApollo, withRouter)(EmbedScripts)
